import { Accordion, AccordionTab } from "primereact/accordion"
import { Badge } from "primereact/badge"
import { Button } from "primereact/button"
import { useEffect, useState } from "react"
import { useAppSelector } from "../../../../../stateManagement/hooks/redux"
import { configureAppliedFiltersFromMapFiltersState, configureMapFiltersStateFromConfig, configureMapFiltersExpressionsFromAppliedFilters, countAllAppliedFilters } from "./mapFiltersFunctions"
import { useMapSlice } from "../../../../../stateManagement/hooks/useMapSlice"
import { MapName } from "../../../../../stateManagement/reducers/maps/actions"
import { useMapDispatch } from "../../../../../stateManagement/hooks/useMapDispatch"
import { useMapURLParams } from "../../../../../hooks/map/useMapParams"
import { classNames } from "primereact/utils"
import { MapCalendarFilter, MapFilter, MapFiltersConfig, MapListCheckboxFilter, MapListRadioFilter, MapTreeCheckboxFilter } from "./types"
import FilterListCheckbox from "./listCheckbox/FilterListCheckbox"
import { getAccordionTabHeaderTemplate } from "./templates"
import { FilterTreeCheckbox } from "./treeCheckbox/FilterTreeCheckbox"
import FilterCalendar from "./calendar/FilterCalendar"
import FilterListRadio from "./listRadio/FilterListRadio"
import { configureTableUnderMapFiltersExpressionsFromAppliedFilters } from "../../../../../pages/tables/tableUnderMap/tableUnderMapFunctions"

const filtersIcon = require('../../../../../assets/images/icons/filters-icon.svg').default

type MapFiltersProps = {
    filtersConfig: MapFiltersConfig;
}

export default function MapFilters({ filtersConfig }: MapFiltersProps) {

    const dispatchMap = useMapDispatch()
    const [allAppliedFiltersNumber, setAllAppliedFiltersNumber] = useState<number | null>(null)
    const tableUnderMapIsShown = useAppSelector(state => state.contentHeader.tableUnderMapIsShown)
    const { mapName } = useMapURLParams() as { mapName: MapName; mapOption?: string };
    const mapState = useMapSlice(mapName)
    const { mapFiltersState, filterMenuActiveTabs, filterMenuIsExpanded, appliedFilters }: any = mapState ?? {};

    useEffect(() => {
        if (!mapFiltersState) {
            const initialMapFiltersState = configureMapFiltersStateFromConfig(filtersConfig)
            dispatchMap(mapName, 'setMapFiltersState', initialMapFiltersState)
        } else {
            const appliedFilters = configureAppliedFiltersFromMapFiltersState(mapFiltersState)
            dispatchMap(mapName, 'setAppliedFilters', appliedFilters)
            const allAppliedFiltersNumber = countAllAppliedFilters(mapFiltersState)
            setAllAppliedFiltersNumber(allAppliedFiltersNumber)
        }
    }, [mapFiltersState])

    useEffect(() => {
        if (appliedFilters) {
            const mapFiltersExpressions = configureMapFiltersExpressionsFromAppliedFilters(appliedFilters);
            dispatchMap(mapName, 'setMapFiltersExpressions', mapFiltersExpressions)
            const tableUnderMapFiltersExpressions = configureTableUnderMapFiltersExpressionsFromAppliedFilters(appliedFilters)
            dispatchMap(mapName, 'setTableUnderMapFiltersExpressions', tableUnderMapFiltersExpressions)
        }
    }, [appliedFilters])

    const filterMenuClassName = classNames({
        "filters-div": true,
        "in-half-size-map": tableUnderMapIsShown
    })

    return (
        <>
            <div className="buttons-div">
                {filterMenuIsExpanded &&
                    <Button onClick={() => dispatchMap(mapName, 'resetAllMapFilters')} className="clear-all-filters">Сбросить все фильтры</Button>
                }
                <div className="filters-button-div p-overlay-badge" onClick={() => dispatchMap(mapName, 'setFilterMenuIsExpanded', !filterMenuIsExpanded)}>
                    <div className="filter-button-image-div">
                        <img src={filtersIcon} />
                    </div>
                    <span>Фильтры</span>
                    {(allAppliedFiltersNumber != null) &&
                        <Badge value={allAppliedFiltersNumber}></Badge>
                    }
                </div>
            </div>
            {filterMenuIsExpanded &&
                <div className={filterMenuClassName}>
                    <Accordion multiple activeIndex={filterMenuActiveTabs} onTabChange={(event) => dispatchMap(mapName, 'setFilterMenuActiveTabs', event.index)}>
                        {filtersConfig.map((filterConfig: MapFilter) => {
                            const { format } = filterConfig ?? {}
                            return (
                                <AccordionTab header={getAccordionTabHeaderTemplate(mapFiltersState, filterConfig, mapName, dispatchMap)}>
                                    {format === "list-checkbox" &&
                                        <FilterListCheckbox filterConfig={filterConfig as MapListCheckboxFilter} />
                                    }
                                    {format === "tree-checkbox" &&
                                        <FilterTreeCheckbox filterConfig={filterConfig as MapTreeCheckboxFilter} />
                                    }
                                    {format === "list-radio" &&
                                        <FilterListRadio filterConfig={filterConfig as MapListRadioFilter} />
                                    }
                                    {format === "calendar" &&
                                        <FilterCalendar filterConfig={filterConfig as MapCalendarFilter} />
                                    }
                                    {/* {filterForm === "input" &&
                                        <CustomFilterInput fieldName={fieldName} objectTypeName={objectTypeName} />
                                    } */}
                                </AccordionTab>
                            )
                        })}
                    </Accordion>
                </div>
            }
        </>
    )
}


